import * as e from "react";
const i = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("rect", { width: 28, height: 28, rx: 12, fill: "#17C964", fillOpacity: 0.15 }), /* @__PURE__ */ e.createElement("path", { d: "M19.3332 10L11.9998 17.3333L8.6665 14", stroke: "#17C964", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
export {
  i as default
};
